import type { ReactNode } from 'react'
import AdminTopNav from '@/layouts/AdminTopNav'
import FlashMessages from '@/components/FlashMessages'
import PlanBanner from '@/components/PlanBanner'
import ImpersonationBanner from '@/components/ImpersonationBanner'

interface AccountLayoutProps {
  children: ReactNode
}

export default function AccountLayout({ children }: AccountLayoutProps) {
  return (
    <div className="min-h-screen bg-base-200">
      <AdminTopNav />
      <ImpersonationBanner />
      <PlanBanner />

      <main className="account-content">
        <FlashMessages />
        {children}
      </main>

      <footer className="px-6 py-3 text-center">
        <p className="text-xs text-base-content/40">
          Powered by{' '}
          <a
            href="https://www.envisialearning.com"
            target="_blank"
            rel="noopener noreferrer"
            className="link link-hover"
          >
            Envisia
          </a>
        </p>
      </footer>
    </div>
  )
}
